import Dropdown from "./Dropdown";
import React from "react";

export default function MoreButton({
  toggleStatus,
  isPublic,
  isOpen,
  onClick,
  dropdownRef,
  onEditPortfolio,
}) {
  return (
    <div className="portfolio-card__btn-wrapper" ref={dropdownRef}>
      <div className="portfolio-card__more-btn" title="More" onClick={onClick}>
        <div className="portfolio-card__button-dot" />
        <div className="portfolio-card__button-dot" />
        <div className="portfolio-card__button-dot" />
        <div className="portfolio-card__btn-bg" />
      </div>
      <Dropdown
        toggleStatus={toggleStatus}
        onEditPortfolio={onEditPortfolio}
        isPublic={isPublic}
        isOpen={isOpen}
      />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/screens/ProductPortfolio/components/MoreButton.js